export const HeaderResults = (props) => {
    return (
        <header className="flex items-center justify-between w-full">
            <div className="header__step">
                <span className="header__number active">
                    {props.index}
                </span>
                <div className="header__divider active"></div>
                <div className="flex flex-col">
                    <span className="header__name">
                        {props.name}
                    </span>
                    <span className="pl-[2px]">
                        {props.sectionName}
                    </span>
                </div>
            </div>
        </header>
    )
}